import React from 'react'

import { Row, Col, Table, Portlet } from '_zari/core'

import * as Sections from './sections'

import { AdminContext } from 'contexts/AdminContext'

const ServiciosPage = () => {
  const __adminContext = React.useContext(AdminContext)

  const [mostrarPaginadoModal, setMostrarPaginadoModal] = React.useState(false)
  const [mesContabilidad, setMesContabilidad] = React.useState(__adminContext.mesTrabajo)

  const tablaRef = React.useRef(null)

  return (
    <>
      <Row>
        <Col md={6}>
          <Sections.VistaPaginadoSection
            setMesContabilidad={setMesContabilidad}
            setMostrarPaginadoModal={setMostrarPaginadoModal}
          />
        </Col>
        <Col md={6}>
          <Sections.DescargarComparacionSection />
        </Col>
      </Row>
      {mostrarPaginadoModal && (
        <Row>
          <Col md={12}>
            <Portlet>
              <Portlet.Body>
                <Table.ServerSide
                  useNest={true}
                  ref={tablaRef}
                  baseParams={{
                    periodo: mesContabilidad
                  }}
                  url='/asientos-contables/sireventas/obtener-paginado'
                  headRows={[
                    {
                      label: 'TIPO DOC',
                      width: 70,
                      align: 'center'
                    },
                    {
                      label: 'SERIE DOC',
                      width: 70,
                      align: 'center'
                    },
                    {
                      label: 'NUM DOC',
                      width: 70,
                      align: 'center'
                    },
                    {
                      label: 'FECHA',
                      width: 70,
                      align: 'center'
                    },
                    {
                      label: 'NUM DOC SOCIO',
                      width: 90,
                      align: 'center'
                    },
                    {
                      label: 'TOTAL',
                      width: 50,
                      align: 'center'
                    }
                  ]}
                  rowTemplate={row => (
                    <Table.Row hover key={row._id}>
                      <Table.Cell align='center'>{row.codTipoCDP || '--'}</Table.Cell>
                      <Table.Cell align='center'>{row.numSerieCDP || '--'}</Table.Cell>
                      <Table.Cell align='center'>{row.numCDP || '--'}</Table.Cell>
                      <Table.Cell align='center'>{row.fecEmision || '--'}</Table.Cell>
                      <Table.Cell align='center'>{row.numDocIdentidad || '--'}</Table.Cell>
                      <Table.Cell align='center'>{row.mtoTotalCP || '--'}</Table.Cell>
                    </Table.Row>
                  )}
                />
              </Portlet.Body>
            </Portlet>
          </Col>
        </Row>
      )}
    </>
  )
}

export default ServiciosPage
